// @flow

import * as React from 'react';
import styles from './styles.scss';

type Props = {
  children: React.Node,
};

const Content = (props: Props): React.Node => <div className={styles.content}>{props.children}</div>;

export default Content;



// WEBPACK FOOTER //
// ./src/containers/Content/index.js